import { render } from "./AddModal.vue?vue&type=template&id=1a34cfec&scoped=true&ts=true"
import script from "./AddModal.vue?vue&type=script&lang=ts"
export * from "./AddModal.vue?vue&type=script&lang=ts"

import "./AddModal.vue?vue&type=style&index=0&id=1a34cfec&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a34cfec"]])

export default __exports__